export enum ProductTechnologyEnum {
    Laser = "LASER",
    Punching = "PUNCHING",
    Combined = "COMBINED",
    Bending = "BENDING",
    Software = "SOFTWARE",
    Co2Laser = "CO2LASER",
    SolidStateLaser = "SOLIDSTATELASER",
    MarkingLaser = "MARKINGLASER",
    AquaCut = "AQUACUT",
    Shear = "TRUSHEAR",
    Automation = "AUTOMATION",
    TwoDLaserCutting = "2DLASERCUTTING",
    ThreeDLaserCutting = "3DLASERCUTTING",
    ThreeDPrinting = "3DPRINTING",
    Cooler = "COOLER",
    DiodeLaser = "DIODELASER",
    DiskLaser = "DISKLASER",
    FiberLaser = "FIBERLASER",
    PulsedLaser = "PULSEDLASER",
    Welding = "WELDING",
    ShortPulsedLaser = "SHORTPULSEDLASER",
    StorageSystem = "STORAGESYSTEM",
    LaserTubeCutting = "LASERTUBECUTTING",
    Electronics = "ELECTRONICS"
}

export type ProductTechnologyType = `${ProductTechnologyEnum}`;
